import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/folder-open': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M527.9 224c37.7 0 60.7 41.5 40.7 73.4l-79.9 128c-8.8 14.1-24.2 22.6-40.7 22.6h-400c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h160l64 64h160c26.5 0 48 21.5 48 48v48h47.9zM48 118v233.4l62.9-104.2c8.7-14.4 24.3-23.2 41.1-23.2h280v-42c0-3.3-2.7-6-6-6h-173.9l-64-64h-134.1c-3.3 0-6 2.7-6 6zM448 400l80-128h-378.8l-77.2 128h376z'
      }
    ]
  }
})
